import g from '#core/global';
import load from '#core/load';
import expandable from '#partial/expandable/expandable';

const group_$ = '.toggle-field-group';
const select_group_$ = '.toggle-field-group--select-style';
const option_$ = '.toggle-field-option';
const option_input_$ = '.toggle-field-option__input';
const option_label_$ = '.toggle-field-option__label';
const group_option_$ = '.toggle-field-group__option';
const search_$ = '[data-toggle-field-group-search]';
const search_clear_$ = '[data-toggle-field-group-search-clear]';
const search_wrap_$ = '.toggle-field-group__search';
const has_query_attr = 'data-has-query';
const match_attr = 'data-match';
const summary_all_attr = 'data-summary-all';
const summary_current_attr = 'data-summary-current';
const summary_delimiter = ', ';
const select_style_responsive_c = 'toggle-field-group--select-style-at-';

let has_group = false;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('toggle-field-group')) return false;
		
		load.content(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
		load.all(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_group) return true;
	
	document.addEventListener(g.change_e, e => {
		const $group = e.target.closest(group_$);
		if (!$group) return;
		
		// Close select group
		if (
			$group.matches(select_group_$)
			|| $group.classList.toString().includes(select_style_responsive_c)
		) {
			const $expandable = $group.closest('.expandable');
			if ($expandable) {
				expandable.toggle({
					id: $expandable.id,
					force: false,
				});
			}
		}
		
		update_summary($group);
	});

	// Live, presentational search filter
	document.addEventListener(g.input_e, e => {
		const $search = e.target.closest(search_$);
		if (!$search) return;

		const $group = $search.closest(group_$);
		if (!$group) return;

		filter_options($group, $search.value.trim().toLowerCase());
		update_search_state($search);
	});

	// Clear the search field when the clear icon is clicked
	document.addEventListener(g.click_e, e => {
		const $clear = e.target.closest(search_clear_$);
		if (!$clear) return;

		const $group = $clear.closest(group_$);
		if (!$group) return;

		const $search = $group.querySelector(search_$);
		if (!$search) return;

		clear_search($group, $search);
		$search.focus();
	});

	// Keyboard handling within the search field
	document.addEventListener(g.key_down_e, e => {
		const $search = e.target.closest(search_$);
		if (!$search) return;

		// Prevent the search field from submitting the surrounding filter form
		if (e.key === 'Enter') {
			e.preventDefault();
			return;
		}

		// Escape clears the field and removes focus
		if (e.key === 'Escape') {
			const $group = $search.closest(group_$);
			if ($group) clear_search($group, $search);
			$search.blur();
		}
	});

	return true;
}


/**
 * Clear the search field and reset the filtered options
 * @param {HTMLElement} $group
 * @param {HTMLElement} $search
 */
function clear_search($group, $search) {
	$search.value = '';
	filter_options($group, '');
	update_search_state($search);
}


/**
 * Reflect whether the search field holds a query so the clear icon can swap in
 * @param {HTMLElement} $search
 */
function update_search_state($search) {
	const $wrap = $search.closest(search_wrap_$);
	if (!$wrap) return;

	$wrap.setAttribute(has_query_attr, $search.value.trim().length ? g.true_s : g.false_s);
}


/**
 * Show only options whose label contains the query. Empty query clears.
 * Purely visual — does not affect checked state or the summary.
 * @param {HTMLElement} $group
 * @param {string} query  lower-cased, trimmed
 */
function filter_options($group, query) {
	$group.querySelectorAll(group_option_$).forEach($option => {
		if (!query.length) {
			$option.removeAttribute(match_attr);
			return;
		}

		const $label = $option.querySelector(option_label_$);
		const text = ($label ? $label.textContent : $option.textContent).toLowerCase();
		$option.setAttribute(match_attr, text.includes(query) ? g.true_s : g.false_s);
	});
}


/**
 * Update the group summary attribute based on checked options
 * @param {HTMLElement} $group
 */
function update_summary($group) {
	const $options = $group.querySelectorAll(option_$);
	
	let summary = [];
	$options.forEach($option => {
		const $option_input = $option.querySelector(option_input_$);
		if (!$option_input || !$option_input.checked) return false;
		
		const $label = $option.querySelector(option_label_$);
		if (!$label) return false;
		
		const label = $label.textContent || '';
		summary.push(label.trim());
	});
	
	summary = summary.filter(x => x).join(summary_delimiter);
	if (!summary.length) {
		summary = $group.getAttribute(summary_all_attr);
	}
	
	// Store summary in data attribute for parent (expandable-field-group) to read
	$group.setAttribute(summary_current_attr, summary);
}
